module.exports = __webpack_public_path__ + "assets/9fb87684a98020c78027e9feb473f958.woff2";